export const socialsData = {
    github: 'https://github.com/swapnali4397/',
    facebook: 'https://www.facebook.com/djswapnali4/',
    linkedIn: 'https://www.linkedin.com/in/swapnali-dukhande-895592136/',
    codepen: 'https://codepen.io/djswapnali',
    twitter: 'https://twitter.com/swapnalidukhan2/',
    stackOverflow: 'https://stackoverflow.com/users/18847083/dj-swapnali/',
    gitlab: 'https://gitlab.com/Codeswap4/',
}